<script setup lang="ts">
import { PropType } from 'vue'
import Product from '~/models/Product/Product'

const props = defineProps({
    product: {
        type: Object as PropType<Product>,
        required: true,
    },

    priceCss: {
        type: String,
        required: false,
        default: '',
    },

    addonSaleBehavior: {
        type: Boolean,
        default: false,
    },
})

const priceBeforeDiscount = computed(() => {
    if (props.addonSaleBehavior) {
        return props.product.priceBeforeDiscount ? Math.max(props.product.priceBeforeDiscount, props.product.price) : props.product.price
    }

    return props.product.priceBeforeDiscount
})

const priceFrom = computed(() => {
    return props.addonSaleBehavior ? null : props.product.priceFrom
})

const price = computed(() => {
    return props.addonSaleBehavior && props.product.attributes.addonSalePrice
        ? props.product.attributes.addonSalePrice
        : props.product.price
})

const emit = defineEmits(['redirectToUrl'])
</script>

<template>
    <a :href="product.url" class="product__price" @click.prevent="emit('redirectToUrl', $event)">
        <s
            v-if="priceBeforeDiscount && priceBeforeDiscount > price"
            class="old me-1 notranslate"
            v-html="$formatCurrency(priceBeforeDiscount)"
        ></s>
        <b v-if="priceFrom" :class="priceCss" v-html="`${$t('productDetail.fromPrice', { price: $formatCurrency(priceFrom) })}`"></b>
        <b v-else-if="price" :class="priceCss" class="notranslate" v-html="$formatCurrency(price)"></b>
    </a>
</template>

<style scoped lang="scss">
@import '../../../node_modules/bootstrap/scss/functions';
@import '../../../node_modules/bootstrap/scss/variables';
@import '../../../node_modules/bootstrap/scss/mixins';

.product {
    &__price {
        color: $color-cta;
        margin-top: 4px;
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: 700;
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;
        text-decoration: none;

        b {
            font-weight: 700;
        }

        &:hover {
            color: $color-cta;
        }

        .old {
            font-weight: 400;
            color: $color-dark;
            font-size: 14px;
            margin-right: 0.5em;
        }

        @include media-breakpoint-up(md) {
            font-size: 16px;
        }
    }
}
</style>
